import { render } from "./ValidityOptionLimitsSettings.vue?vue&type=template&id=59a775ac"
import script from "./ValidityOptionLimitsSettings.vue?vue&type=script&lang=js"
export * from "./ValidityOptionLimitsSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__